<template lang="html">
    <section class='wrapper'>
        <div class="notify mt-5" :class="{'notify-expand' : expand, 'slim':!notification.image}" @click="notification.image ? expand = !expand : null">
            <div class="collpase">
    
                <a :href="notification.image" target="_blank" v-if="!expand">
                         <img ref="image" v-if="notification.image && !expand" class="image" :src="notification.image" @load="imageLoaded" />
                        </a>
                <div class="content">
                    <div class="header">
                        <img class="kanlogo" src="/img/icons/kan_logo.svg" />
                        <div class="time">14:23</div>
                    </div>
                    <div class="notifytitle">{{notification.title}}</div>
                    <div class="body" :class="{'body-expand' : !notification.image && expand}">{{notification.body}}</div>
                </div>
            </div>
            <div class="expanded" v-if="expand">
                <a :href="notification.image" target="_blank">
                        <img v-if="notification.image && expand" class="image-expand" :src="notification.image" />
                        </a>
            </div>
        </div>
    </section>
</template>

<script lang="js">
export default {
    name: 'notify',
    mounted() {

    },
    data() {
        return {
            expand: false
        }
    },
    methods: {
        imageLoaded(img) {
            this.notification.imageAspectRatio = this.$refs.image.naturalHeight / this.$refs.image.naturalWidth
        }
    },
    computed: {
        notification() {
            return this.$store.getters.notification
        },
        appIcon() {
            return `/img/icons/app_logo_${this.$route.params.app}.png`
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    display: flex;
    justify-content: center;
    height: 200px;
    width: 100%;
}

.space {
    flex: 1 1 auto;
}

.notify {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 90px;
    width: 88%;
    background-color: #ffffff;
    color: black;
    transition: height 0.25s ease-in;
    overflow: hidden;
    cursor: pointer;
}

.slim {
    height: 60px;
}

.notify-expand {
    height: 235px;
    transition: height 0.25s ease-in;
    .content {
        padding-right: 10px;
    }
}

.collpase {
    width: 100%;
    display: flex;
}

.header {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.main {
    padding-top: 5px;
}

.notifytitle {
    font-size: 14px;
    font-weight: bolder;
}

.expand-invert {
    transform: rotate(-180deg);
}

.expand {
    cursor: pointer;
}

.body {
    color: grey;
    font-size: 13px;
    overflow: hidden;
    transition: height 0.25s ease-in;
    text-overflow: ellipsis;
}

.body-expand {
    height: 130px;
    width: 100%;
    transition: height 0.25s ease-in;
    white-space: normal;
}

.app {
    color: gray;
    margin-right: 5px;
    font-size: 12px;
}

.image {
    height: 90px;
    width: 90px;
    flex: 0 0 50px;
    object-fit: cover;
}

.image-expand {
    height: 164px;
    width: 292px;
    object-fit: cover;
}

.content {
    width: 100%;
    flex: auto;
    padding: 5px;
    line-height: 1.3;
}

.app_icon {
    height: 15px;
    width: 15px;
    outline: 0.5px solid grey;
}

.kanlogo {
    height: 16px
}

.time {
    font-size: 10px
}
</style>
